import { Funcionario, funcionario } from 'service/api'

import { CreateSlice } from './index'

export type EmployeeState = {
    employeeId: number
    employeeIds: number[]
    employee: Funcionario | null
    incluirDemitidos: boolean
    setEmployeeId: (id: number) => void
    setEmployeeIds: (ids: number[]) => void
    setIncluirDemitidos: (incluir: boolean) => void
}

export const createEmployeeSlice: CreateSlice<EmployeeState> = (set, get) => ({
    employeeId: -1,
    employeeIds: [],
    employee: null,
    incluirDemitidos: false,
    // Não escreve `employeeIds`: essa lista é o escopo do relatório e filtra as
    // linhas. Telas de seleção única (espelho, digitação) usam só `employeeId`
    // — propagar para a lista faria elas filtrarem os relatórios sem pedir.
    setEmployeeId: (id: number) => {
        if (get().employeeId === id) return
        set({ employeeId: id, employee: null })

        funcionario.getById(id).then(
            fetched => {
                if (get().employeeId === id) {
                    set({ employee: fetched as Funcionario })
                }
            },
            () => {
                // On error (404 / network), keep employeeId set, employee null.
                // React Query retry handles recovery.
            },
        )
    },
    setEmployeeIds: (ids: number[]) => {
        const first = ids[0] ?? -1
        set({ employeeIds: ids, employeeId: first })
    },
    setIncluirDemitidos: (incluir: boolean) => {
        set({ incluirDemitidos: incluir })
    },
})
